import { isNullish } from 'remeda';

type TWrapArrayReturn<T> = T extends unknown[] ? T : T[];

export function wrapArray<T>(data?: T): TWrapArrayReturn<T> {
  if (isNullish(data)) {
    return [] as TWrapArrayReturn<T>;
  }

  return (Array.isArray(data) ? data : [data]) as TWrapArrayReturn<T>;
}

interface ICalArrAverageProps {
  arr: number[];
}

export function calArrAverage({ arr }: ICalArrAverageProps): number {
  return arr.reduce((acc, item) => acc + item, 0) / (arr.length || 1);
}

export function compactArray<T>(data: T[]): T[] {
  return data.filter((item) => !isNullish(item));
}
